import React, { useCallback, useEffect, useState } from 'react';
import { Col, InputNumber, Modal, Row, Button, notification, Card } from 'antd';
import { FormInstance } from 'antd/lib/form';
import ParListSelect from 'components/ParListSelect';
import InputRate from 'components/InputRate';
import PricingListSelect from 'components/PricingListSelect';
import ServiceScheduleModal from 'components/ServiceScheduleModal';
import ScheduleButton from 'components/ScheduleButton';
import IUpdate from 'icons/IUpdate';
import IAdd from 'icons/IAdd';
import * as finEngine from 'services/finEngine';
import FormItem from 'antd/lib/form/FormItem';
import { commissionToElement } from './commissionToElement';
import { PricingResponse } from 'services/pricing';
import moment from 'moment';
import InputCurrency from 'components/InputCurrency';
import { isEmpty } from 'lodash';
import GetLabel from 'DisplayFramework/components/GetLabel';

export type SimpleCommissionModalProps = {
  updateCommission?: boolean;
  visible?: boolean;
  onSave: (serv: any, action: string) => void;
  onClose?: any;
  record?: any;
  offerid?: any;
  finschedule?: any;
  form?: FormInstance;
  ctegraceperiodduration: number;
  ctefinancedamount: number;
  index?: number;
  assetid?: number;
  cteinvestamount: number;
  ctestartdate: string;
  cteduration: number;
  assetamount: number;
};

const SimpleCommissionModal = (props: SimpleCommissionModalProps) => {
  const {
    onSave,
    visible = false,
    onClose,
    record,
    updateCommission,
    offerid,
    finschedule,
    form,
    ctegraceperiodduration,
    ctefinancedamount,
    index,
    cteinvestamount,
    ctestartdate,
    cteduration,
    assetamount,
  } = props;

  const initobj = {
    commtype: '',
    commbasis: '',
    calculatedamountbasis: '',
    commduration: '',
    commperiodicity: '',
    commdurationdefault: 0,
    commcalculationmethod: '',
    commfixedamount: 0,
    commpercentage: 0,
    marginoncalulatedcamount: 0,
    additionalcostaftermargin: 0,
  };

  const [state, setstate] = useState<any>({
    installementamount: 0,
    pricing: {},
    comElement: updateCommission ? record : initobj,
  });

  const reset = useCallback(() => {
    form?.setFieldsValue({
      commbasis: '',
    });
    form?.setFieldsValue({
      additionalcostaftermargin: 0,
    });
    form?.setFieldsValue({
      calculatedamountbasis: '',
    });
    form?.setFieldsValue({
      marginoncalulatedcamount: 0,
    });
    form?.setFieldsValue({
      commcalculationmethod: '',
    });
    form?.setFieldsValue({
      commduration: '',
    });
    form?.setFieldsValue({
      commdurationdefault: 0,
    });
    form?.setFieldsValue({
      commfixedamount: 0,
    });
    form?.setFieldsValue({
      commpercentage: 0,
    });
    form?.setFieldsValue({
      commperiodicity: '',
    });
    form?.setFieldsValue({
      commtype: '',
    });
    setstate({ ...state, comElement: updateCommission ? record : initobj });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (record && form && updateCommission) {
      form.setFieldsValue({
        commbasis:
          record?.commissionResponse.commbasislabel === ''
            ? record?.commissionResponse.commbasis
            : record?.commissionResponse.commbasislabel ?? '',

        additionalcostaftermargin: record?.additionalcostaftermargin ?? 0,

        calculatedamountbasis: record?.ctecalculationbasis ?? '',

        marginoncalulatedcamount: record?.marginoncalulatedcamount ?? 0,

        commcalculationmethod:
          record?.commissionResponse.commcalculationmethod === ''
            ? record?.commissionResponse.commcalculationmethodlabel
            : record?.commissionResponse.commcalculationmethod ?? '',

        commduration: record?.commissionResponse.commduration ?? '',

        commdurationdefault:
          record?.commissionResponse.commdurationdefault ?? 0,
        commfixedamount:
          record?.servfixedamount ??
          record?.commissionResponse.commfixedamount ??
          0,
        commpercentage:
          record?.servpercentage ??
          record?.commissionResponse.commpercentage ??
          0,
        commperiodicity: record?.commissionResponse.commperiodicity ?? '',

        commtype: record?.commissionResponse.commtype ?? '',
      });
      calculateCommissionNew(record);
    } else reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record, form, visible, updateCommission]);
  const [disable, setdisable] = useState(updateCommission ? false : true);

  const handlePricingChange = (pricing: any) => {
    state.pricing = pricing;

    if (pricing != null && form) {
      form.setFieldsValue({
        commbasis: pricing?.commissionResponse?.commbasis ?? '',
      });
      form.setFieldsValue({
        additionalcostaftermargin:
          pricing?.commissionResponse?.additionalcostaftermargin ?? 0,
      });
      form.setFieldsValue({
        calculatedamountbasis: pricing?.calculationbasis ?? '',
      });
      form.setFieldsValue({
        marginoncalulatedcamount: 0,
      });

      form.setFieldsValue({
        commcalculationmethod:
          pricing?.commissionResponse?.commcalculationmethod ?? '',
      });
      form.setFieldsValue({
        commduration: pricing?.commissionResponse?.commduration ?? '',
      });
      form.setFieldsValue({
        commdurationdefault:
          pricing?.commissionResponse?.commdurationdefault ?? 0,
      });
      form.setFieldsValue({
        commfixedamount: pricing?.commissionResponse?.commfixedamount ?? 0,
      });
      form.setFieldsValue({
        commpercentage: pricing?.commissionResponse?.commpercentage ?? 0,
      });
      form.setFieldsValue({
        commperiodicity: pricing?.commissionResponse?.commperiodicity ?? '',
      });
      form.setFieldsValue({
        commtype: pricing?.commissionResponse?.commtype ?? '',
      });

      state.comElement.servpercentage =
        pricing?.commissionResponse?.commpercentage;
      state.comElement.servfixedamount =
        pricing?.commissionResponse?.commfixedamount;

      calculateCommissionNew(pricing);
      setdisable(false);
    }
  };

  const [schedule, setschedule] = useState<any>({ schedule: [] });
  // let result = {};
  const calculateCommissionNew = (commElement: any) => {
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule:
            finschedule.length === 0 ? record.conElemSchedules : finschedule,
          inDownPayment: 0,
          inFinAmount: ctefinancedamount,
          inFollowGP: true,
          inGPDuration: ctegraceperiodduration,
          inPstype: updateCommission
            ? commElement.ctecategory
            : state.pricing.ctecategory,
          inRoudingAmount: 2,
          inServcalculationmethod:
            form?.getFieldValue('commcalculationmethod') ??
            commElement?.commissionResponse?.commcalculationmethod,

          inServfixedamount:
            form?.getFieldValue('commfixedamount') ??
            commElement.commissionResponse.commfixedamount,
          inServiceduration:
            form?.getFieldValue('commduration') ??
            commElement?.commissionResponse?.commduration,
          inServpercentage:
            form?.getFieldValue('commpercentage') ??
            commElement?.commissionResponse?.commpercentage,

          inTaxcode: updateCommission
            ? commElement?.taxcode
            : state.pricing.taxcode,
          inTaxrate: 20, // TODO : get taxrate :
          inDuration: cteduration,
          inInvestAmount: cteinvestamount,
          inAssetAmount: assetamount,
          inServperiodicity: commElement.commissionResponse?.commperiodicity,
          inServDurationFree:
            commElement.commissionResponse?.commdurationdefault,

          inStartDate: ctestartdate
            ? moment(ctestartdate).format('YYYY-MM-DD')
            : '',
          inServbasis:
            form?.getFieldValue('commbasis') ??
            commElement.commissionResponse?.commbasis,

          inCalculatedamountbasis: 'ANNUAL',

          inMarginoncalcultedamount: 0,
          inAdditionalcostaftermargin: 0,

          servStep: [],
        },
      })
      .then((res) => {
        if (res.success) {
          setschedule({ ...schedule, schedule: res.paymentSchedule });
          setstate({ ...state, installementamount: res.installmentamount });
          // result = res;
        }
      });
  };

  const newelem = () => {
    const price = state.pricing;

    const comm = { ...state.comElement };
    /*  const comm =state.comElement.commfixedamount === 0
        ? { ...price.commissionResponse }
        : { ...state.comElement };
*/
    // eslint-disable-next-line no-unused-vars
    const newobj = updateCommission
      ? price.commissionResponse
      : { ...price.commissionResponse, ...comm };
    const obj: PricingResponse = {
      ...price,
      ...comm,
      pricing: price,
      conElemSchedules: schedule.schedule,
      cteinstallmentamount: state.installementamount,
      commissionResponse: {
        ...price.commissionResponse,
        commfixedamount: state.comElement.commfixedamount,
        commpercentage: state.comElement.commpercentage,
      },
    };
    const offer = { ofrid: 0, ofrlabel: '', ofrtype: '', ofrdescription: '' };
    const res = commissionToElement(
      offer,
      obj as PricingResponse,
      obj.commissionResponse,
      form?.getFieldValue('selectedElement'),
      cteinvestamount!
    );
    return res;
  };

  const updateElem = () => {
    const updatedobject = {
      ...state.comElement,
      conElemSchedules: schedule.schedule,
      cteinstallmentamount: state.installementamount,
      servfixedamount: state.comElement.commfixedamount,
      servpercentage: state.comElement.commpercentage,
      index: index,
    };

    return updatedobject;
  };

  return (
    (<div onClick={(e) => e.stopPropagation()}>
      <Modal
        open={visible}
        title={<GetLabel label={updateCommission ? 'Update Commission' : 'Add Commission'}/>}
        onCancel={() => {
          onClose();
        }}
        width="1000px"
        style={{ top: 20 }}
        footer={null}
        destroyOnClose
       
      >
        <Card>
          <Row>
            <Col span={13} />
            <Col span={5}>
              <ServiceScheduleModal
                currcode={form?.getFieldValue('currcode')}
                financialSchedule={schedule.schedule}
                controller={
                  <ScheduleButton
                    comcode="PaymentScheduleButton"
                    twoToneColor="blue"
                  />
                }
              />
            </Col>
            <Col span={2}>
              <Button key="Cancel" onClick={onClose}>
              <GetLabel label='Cancel'/>
                
              </Button>{' '}
            </Col>
            <Col span={4}>
              <Button
                key="Validate"
                type="primary"
                onClick={() => {
                  if (isEmpty(state.pricing)) {
                    notification.error({ message: 'Select Pricing' });
                  } else {
                    onSave(
                      updateCommission ? updateElem() : newelem(),
                      updateCommission ? 'update' : 'create'
                    );
                    onClose();
                  }
                }}
                icon={
                  updateCommission ? (
                    <IUpdate color="white" height="16px" width="13px" />
                  ) : (
                    <IAdd
                      color="white"
                      width="14px"
                      height="14px"
                      svgstyle={{ marginTop: '3px' }}
                    />
                  )
                }
              >
                <GetLabel label={updateCommission ? 'Update' : 'Add'}/>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col span={6}>
              <Col> <GetLabel label='PricingList :'/></Col>

              <PricingListSelect
                style={{ width: '200px' }}
                params={{
                  offerid: offerid,
                  ctecategory: '',
                  ctetype: 'COMM',
                  filters: '',
                  finamount: 0,
                }}
                defaultValue={record?.pricing?.priid}
                allowClear
                disabled={updateCommission}
                onChange={(e) => {
                  handlePricingChange(e);
                }}
              />
            </Col>
            <Col span={6}>
              <Col><GetLabel label='Type :'/></Col>
              <FormItem name="commtype">
                <ParListSelect
                  style={{ width: '200px' }}
                  parcode="CTETYPE"
                  disabled
                  onSelect={(e) => {
                    state.comElement.commtype! = e;
                  }}
                />
              </FormItem>
            </Col>
            <Col span={6}>
              <Col><GetLabel label='commbasis :'/></Col>
              <FormItem name="commbasis">
                <ParListSelect
                  style={{ width: '200px' }}
                  parcode="COMMBASIS"
                  disabled
                  onSelect={(e) => (state.comElement.commbasis = e)}
                />
              </FormItem>
            </Col>
            <Col span={6}>
              <Col><GetLabel label='calculatedamountbasis :'/></Col>
              <FormItem name="calculatedamountbasis">
                <ParListSelect
                  style={{ width: '200px' }}
                  parcode="SERVCALMNT"
                  disabled
                  onSelect={(e) => (state.comElement.calculatedamountbasis = e)}
                />
              </FormItem>
            </Col>
          </Row>
          <br />
          <Row>
            <Col span={6}>
              <Col><GetLabel label='commduration :'/></Col>
              <FormItem name="commduration">
                <ParListSelect
                  parcode="SERVDUR"
                  style={{ width: '200px' }}
                  disabled
                  onSelect={(e) => (state.comElement.commduration! = e)}
                />
              </FormItem>
            </Col>
            <Col span={6}>
              <Col><GetLabel label='commperiodicity :'/></Col>
              <FormItem name="commperiodicity">
                <ParListSelect
                  style={{ width: '200px' }}
                  parcode="SERVPER"
                  disabled
                  onSelect={(e) => {
                    state.comElement.commperiodicity = e;
                  }}
                />
              </FormItem>
            </Col>
            <Col span={6}>
              <Col><GetLabel label='commdurationdefault :'/></Col>
              <FormItem name="commdurationdefault">
                <InputNumber
                  style={{ width: '200px' }}
                  disabled
                  onChange={(e) =>
                    (state.comElement.commdurationdefault! = Number(e))
                  }
                />
              </FormItem>
            </Col>

            <Col span={6}>
              <Col><GetLabel label='commcalculationmethod :'/></Col>
              <FormItem name="commcalculationmethod">
                <ParListSelect
                  style={{ width: '200px' }}
                  parcode="SERVCALMET"
                  disabled
                  onChange={(e) => {
                    state.comElement.commcalculationmethod! = e;
                  }}
                />
              </FormItem>
            </Col>
          </Row>
          <br />
          <Row>
            <Col span={6}>
              <Col><GetLabel label='commfixedamount :'/></Col>
              <FormItem name="commfixedamount">
                <InputCurrency
                  col
                  md={21}
                  currcode={form?.getFieldValue('currcode') ?? localStorage.getItem('currcode') ?? ''}
                  style={{ width: '150px' }}
                  onChange={(e) => {
                    state.comElement.commfixedamount! = Number(e);
                    calculateCommissionNew(state.comElement);
                  }}
                  disabled={
                    record?.commissionResponse.commcalculationmethod ===
                      'PERCENT' || disable
                  }
                />
              </FormItem>
            </Col>
            <Col span={5}>
              <Col><GetLabel label='commpercentage :'/></Col>
              <FormItem name="commpercentage" shouldUpdate>
                <InputRate
                  precision={2}
                  style={{ width: '100px' }}
                  onChange={(e) => {
                    state.comElement.commpercentage! = Number(e);
                    if (updateCommission) {
                      calculateCommissionNew(state.comElement);
                    }
                  }}
                  disabled={
                    record?.commissionResponse.commcalculationmethod ===
                      'FIXED' || disable
                  }
                />
              </FormItem>
            </Col>
            <Col span={7}>
              <Col><GetLabel label='marginoncalulatedcamount:'/></Col>
              <FormItem name="marginoncalulatedcamount">
                <InputRate
                  precision={2}
                  style={{ width: '100px' }}
                  onChange={(e) => {
                    state.comElement.marginoncalulatedcamount = Number(e);

                    if (updateCommission) {
                      calculateCommissionNew(state.comElement);
                    }
                  }}
                  disabled={
                    (!(
                      record?.commissionResponse.commcalculationmethod ===
                      'FIXPERMAR'
                    ) &&
                      updateCommission) ||
                    disable
                  }
                />
              </FormItem>
            </Col>
            <Col span={6}>
              <Col><GetLabel label='additionalcostaftermargin :'/></Col>
              <FormItem name="additionalcostaftermargin">
                <InputRate
                  precision={2}
                  style={{ width: '100px' }}
                  onChange={(e) => {
                    state.comElement.additionalcostaftermargin = Number(e);

                    if (updateCommission) {
                      calculateCommissionNew(state.comElement);
                    }
                  }}
                  disabled={
                    (!(
                      record?.commissionResponse.commcalculationmethod ===
                      'FIXPERMAR'
                    ) &&
                      updateCommission) ||
                    disable
                  }
                />
              </FormItem>
            </Col>
          </Row>
        </Card>
      </Modal>
    </div>)
  );
};

export default SimpleCommissionModal;
